import React, { useRef, useState } from 'react';
import IconButton from '@mui/material/IconButton';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import Slider from '@mui/material/Slider';
import Box from '@mui/material/Box';
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';

const AudioPlayer = ({ audioUrl, filenameToDownload }) => {
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [volume, setVolume] = useState(0.7);
  const [isMuted, setIsMuted] = useState(false);


    const downloadFile = async () => {
        const link = document.createElement('a');
        link.href = audioUrl;
        link.download = filenameToDownload;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }


  // Manejar play/pause
  const togglePlayPause = () => {
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  // Actualizar barra de progreso
  const handleTimeUpdate = () => {
    setCurrentTime(audioRef.current.currentTime);
    setDuration(audioRef.current.duration || 0);
  };

  // Cambiar posición de reproducción
  const handleSeek = (event, newValue) => {
    audioRef.current.currentTime = newValue;
    setCurrentTime(newValue);
  };

  // Manejar volumen
  const handleVolumeChange = (event, newValue) => {
    const newVolume = newValue / 100;
    audioRef.current.volume = newVolume;
    setVolume(newVolume);
    setIsMuted(newVolume === 0);
  };

  // Alternar silencio
  const toggleMute = () => {
    audioRef.current.muted = !isMuted;
    setIsMuted(!isMuted);
  };

  // Formatear tiempo (mm:ss)
  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
      {/* Elemento de audio oculto */}
      <audio
        ref={audioRef}
        src={audioUrl}
        onTimeUpdate={handleTimeUpdate}
        onEnded={() => setIsPlaying(false)}
        onLoadedMetadata={handleTimeUpdate}
      />
      

      {/* Botón de Download */}
      <IconButton onClick={downloadFile} color="primary">
        <CloudDownloadOutlinedIcon />
      </IconButton>


      {/* Botón de play/pause */}
      <IconButton onClick={togglePlayPause} color="primary">
        {isPlaying ? <PauseIcon /> : <PlayArrowIcon />}
      </IconButton>
      
      {/* Barra de progreso */}
      <Slider
        value={currentTime}
        max={duration}
        onChange={handleSeek}
        sx={{ flexGrow: 1 }}
      />
      
      {/* Tiempo transcurrido/total */}
      <Box sx={{ minWidth: 80, textAlign: 'center' }}>
        {formatTime(currentTime)} / {formatTime(duration)}
      </Box>
      
      {/* Control de volumen */}
      <Box sx={{ display: 'flex', alignItems: 'center', width: 150 }}>
        <IconButton onClick={toggleMute}>
          {isMuted || volume === 0 ? <VolumeOffIcon /> : <VolumeUpIcon />}
        </IconButton>
        {/* <Slider
          value={volume * 100}
          onChange={handleVolumeChange}
          sx={{ ml: 1 }}
        /> */}
      </Box>
    </Box>
  );
};

export default AudioPlayer;